import React from "react";
import { connect } from "react-redux";
import { applySpec, path, pipe } from "ramda";
import {
  mediaItemFieldChanged,
  blurMediaItemField,
} from "edit-media/redux/editMediaActions";
import {
  getCategories,
  getEditMediaItem,
  getEditMediaErrors,
} from "common/selectors";
import { getAutocompleteSource } from "util/componentUtil";
import Autocomplete from "components/Autocomplete";
import { Dropdown } from "react-toolbox/lib/dropdown";
import { Input } from "react-toolbox/lib/input";
import styles from "edit-media/components/EditMediaGeneralTab.css";
import dropdownTheme from "shared-styles/DropdownTheme.css";

const textDirections = [
  { value: "LTR", label: "Left to Right" },
  { value: "RTL", label: "Right to Left" },
];

const EditMediaInfoBook = ({
  categories,
  errors,
  media,
  onFieldChange,
  onFieldBlur,
}) => (
  <div>
    <Input
      className={styles.field}
      label="Publisher"
      onChange={onFieldChange(["publisherName"])}
      value={media.publisherName}
    />
    <Input
      className={styles.field}
      label="Place Of Publication"
      onChange={onFieldChange(["placeOfPublication"])}
      value={media.placeOfPublication}
    />
    <Input
      className={styles.field}
      label="Volume"
      onChange={onFieldChange(["volume"])}
      value={media.volume}
    />
    <Input
      className={styles.field}
      label="Edition"
      onChange={onFieldChange(["edition"])}
      value={media.edition}
    />
    <Autocomplete
      className={styles.field}
      direction="down"
      label="Primary Category"
      multiple={false}
      showSuggestionsWhenValueIsSet={true}
      suggestionMatch="anywhere"
      source={categories}
      value={path(["bisacCategories", 0, "id"], media) || ""}
      onChange={onFieldChange(["bisacCategories", 0, "id"])}
      // onBlur={partial(onFieldBlur, ["bisacCategories"])}
    />
    <Autocomplete
      className={styles.field}
      direction="down"
      label="Secondary Category (Optional)"
      multiple={false}
      showSuggestionsWhenValueIsSet={true}
      suggestionMatch="anywhere"
      source={categories}
      value={path(["bisacCategories", 1, "id"], media) || ""}
      onChange={onFieldChange(["bisacCategories", 1, "id"])}
      // onBlur={partial(onFieldBlur, ["bisacCategories"])}
    />
    <Autocomplete
      className={styles.field}
      direction="down"
      label="Tertiary Category (Optional)"
      multiple={false}
      showSuggestionsWhenValueIsSet={true}
      suggestionMatch="anywhere"
      source={categories}
      value={path(["bisacCategories", 2, "id"], media) || ""}
      onChange={onFieldChange(["bisacCategories", 2, "id"])}
      // onBlur={partial(onFieldBlur, ["bisacCategories"])}
    />
    <Dropdown
      label="Text Directionality"
      auto={false}
      source={textDirections}
      value={media.textDirectionality}
      onChange={onFieldChange(["textDirectionality"])}
      theme={dropdownTheme}
    />
    <Input
      className={styles.field}
      label="Rating"
      onChange={onFieldChange(["rating"])}
      value={media.rating}
    />
    <Input
      className={styles.field}
      label="ISBN"
      onChange={onFieldChange(["isbn"])}
      value={media.isbn}
      maxLength={13}
    />
    <Input
      className={styles.field}
      label="ISSN"
      onChange={onFieldChange(["issn"])}
      value={media.issn}
      maxLength={8}
    />
    <Input
      className={styles.field}
      label="DOI"
      onChange={onFieldChange(["doi"])}
      value={media.doi}
    />
    <Input
      className={styles.field}
      label="Internal Publisher Id"
      onChange={onFieldChange(["internalPublisherId"])}
      value={media.internalPublisherId}
    />
  </div>
);

const mapStateToProps = applySpec({
  categories: pipe(getCategories, getAutocompleteSource),
  errors: getEditMediaErrors,
  media: getEditMediaItem,
});

const mapDispatchToProps = dispatch => ({
  onFieldChange: path => value => dispatch(mediaItemFieldChanged(path, value)),
  onFieldBlur: (field, value) => dispatch(blurMediaItemField(field, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditMediaInfoBook);
